import { BookingType } from "../../../features/Booking-Form/typings/booking-inputs";

const BOOKING_TYPES_WITH_FAVORITES = new Set<BookingType>([
  BookingType.WORKPLACE,
  BookingType.PARKINGPLACE,
  BookingType.ELECTRICCHARGINGSTATIONPLACE,
  BookingType.CONFERENCEZONE
]);

export function isBookingTypeWithFavorites(
  mode: BookingType | null | undefined
): mode is BookingType {
  return mode != null && BOOKING_TYPES_WITH_FAVORITES.has(mode);
}
